/**Dependencies */
import React, { useEffect, useState } from "react";

// Styles
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import { booking, getInfoReserva } from "../services/Booking";
import { ReservaConfirmada } from "../components/ReservaConfirmada";
import { ErrorReserva } from "../components/ErrorReserva";
import {
  getEmailConfirmReserva,
  getEmailErrorReserva,
  getEmailPagoExitoso,
} from "../services/emailService";

export const ConfirmReserva = () => {
  const [dataCart, setDataCart] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva"))
  );

  const [reservaSession, setReservaSession] = useState(
    JSON.parse(sessionStorage.getItem("reservaSession")) || null
  );
  const [reserva, setReserva] = useState({});
  const [reservaInfo, setReservaInfo] = useState([]);
  const [totalHotel, setTotalHotel] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const queryParams = parseQueryParams(location.search);

  useEffect(() => {
    // if (reservaSession !== null) {
    //   sessionStorage.clear();
    //   navigate("/");
    // } else {
    bookingReserva();
    // }
  }, []);

  const hotel = {
    hotel: dataCart?.hospedaje,
  };
  const bookingReserva = async () => {
    let req;
    if (dataCart.idPasarela == "CONEKTA") {
      req = {
        idPasarela: dataCart.idPasarela,
        idTransaccion: queryParams.order_id,
        carrito: hotel,
      };
    } else if (dataCart.idPasarela == "OPENPAY") {
      req = {
        idPasarela: dataCart.idPasarela,
        idTransaccion: queryParams.id,
        carrito: hotel,
      };
    }
    try {
      const response = await booking(req);

      infoReserva(response.idReserva);
      setReserva(response);
      const reservaSessions = sessionStorage.setItem(
        "reservaSession",
        JSON.stringify(response)
      );
      setReservaSession(reservaSessions);
      sendMails(response);
    } catch (error) {
      throw new Error("error connection", error);
    }
  };

  const sendMails = async (res) => {
    if (res.error == true) {
      const dataErrorEmail = {
        destinatario: res.emailTitular,
        destinatarioCC: "",
        asunto: "Reservacion International Travel Net",
        mensaje: "Error en la reserva",
        infoError: res,
      };
      const errorMail = await ErrorEmail(dataErrorEmail);
      return errorMail;
    } else {
      const dataEmailConfirm = {
        destinatario: res.emailTitular,
        destinatarioCC: "",
        asunto: "Reservacion International Travel Net",
        mensaje: "Reservacion confirmada",
        rateComments: rateComments,
        responseReserva: res,
      };

      const dataEmailPagoExitoso = {
        destinatario: res.emailTitular,
        destinatarioCC: "",
        asunto: "Pago Exitoso International Travel Net",
        mensaje: "Pago exitoso",
        idReserva: res.idReserva,
      };
      const confirmMail = await sendEmailConfirm(dataEmailConfirm);
      const pagoExitosoMail = await pagoExitosoEmail(dataEmailPagoExitoso);
      return { confirmMail, pagoExitosoMail };
    }
  };
  const infoReserva = async (idReserva) => {
    try {
      const response = await getInfoReserva({ idReserva: idReserva });
      setReservaInfo(response);
    } catch (error) {
      throw new Error("error connection", error);
    }
  };
  useEffect(() => {
    const totalReserva = async () => {
      const total = await reserva?.totalPago;
      let subtotal = total / 1.16;
      let impuesto = total - subtotal;
      setTotalHotel({ subtotal, impuesto, total });
    };
    totalReserva();
  }, [reservaInfo]);

  const ErrorEmail = async (dataError) => {
    try {
      const response = await getEmailErrorReserva(dataError);
      return response;
    } catch (error) {
      throw new Error("error", error);
    }
  };

  const sendEmailConfirm = async (dataConfirm) => {
    try {
      const response = await getEmailConfirmReserva(dataConfirm);
      return response;
    } catch (error) {
      throw new Error("error", error);
    }
  };

  const pagoExitosoEmail = async (dataPagoSuccess) => {
    try {
      const response = await getEmailPagoExitoso(dataPagoSuccess);
      return response;
    } catch (error) {
      throw new Error("error", error);
    }
  };

  const rateComments = dataCart?.hospedaje?.map((hotel) => {
    return hotel?.comentario;
  });

  return (
    <div
      style={
        Object.keys(reserva).length > 0
          ? {
              backgroundImage:
                "url('https://panel.internationaltravelnet.com.mx/assets/img/Fondo-de-correos-1.png')",
              backgroundRepeat: "repeat",
              backgroundSize: "contain",
              width: "100%",
            }
          : {
              backgroundImage:
                "url('https://panel.internationaltravelnet.com.mx/assets/img/Fondo-de-correos-1.png')",
              backgroundRepeat: "repeat",
              backgroundSize: "contain",
              width: "100%",
              height: "100vh",
            }
      }
    >
      <Button
        className="m-3 btn-blue"
        style={{ fontSize: "1.7rem" }}
        onClick={() => [navigate("/"), sessionStorage.clear()]}
      >
        Regresar al Home
      </Button>
      {Object.keys(reserva).length > 0 && (
        <>
          {reserva.error === false && reservaInfo ? (
            <div className="container d-flex justify-content-center position-relative">
              <div className="bg-white p-5 pb-2 m-5 shadow rounded">
                <ReservaConfirmada
                  arrReserva={dataCart?.hospedaje}
                  arrReservaInfo={reservaInfo}
                  reserva={reserva}
                  totalReservaHotelera={totalHotel}
                />
              </div>
            </div>
          ) : (
            <div className="container d-flex justify-content-center position-relative">
              <div className="bg-white p-5 pb-2 m-5 shadow rounded">
                <ErrorReserva
                  reserva={reserva}
                  idTransaccion={queryParams.id}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
